import { connect } from 'react-redux';
import { compose } from 'redux';
import PanelBorder from '../../components/handoff/PanelBorder';
import onlyIf from '../../hocs/onlyIf';
import { getSelectedElement } from '../../selectors/handoff';
import * as handoff from '../../utils/handoff/element';
function mapStateToProps(state) {
    var element = getSelectedElement(state);
    return {
        borders: handoff.getElementBorders(element),
    };
}
export default compose(connect(mapStateToProps), onlyIf(function (props) { return props.borders.length; }))(PanelBorder);
